// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__TZkIW","label":"SetPasswdForm_label__1Gnno"};